module.exports = __webpack_public_path__ + "static/media/aiDesignerAxisTemplate1.c60645ef.jpg";